import type { VotingAccessMode } from "./types";

type VotingLike = { access_mode?: VotingAccessMode | string | null } | null | undefined;

/**
 * True when the canvas admits any voter.
 *
 * Mirrors `voting_is_enabled()` in base.canvas.models. Prefer this over an
 * inline `voting?.access_mode !== "off"`: optional chaining yields `undefined`
 * for a canvas with voting off, and `undefined !== "off"` is `true`.
 */
export function isVotingEnabled(voting: VotingLike): boolean {
  const mode = voting?.access_mode;
  return mode === "anonymous" || mode === "authenticated";
}
